export default __webpack_public_path__ + "af56d42aded84edef68b6956d27d03f4.svg";